import { createFileRoute } from "@tanstack/react-router";
import AdminMediaDetailPage from "@/admin/pages/media-detail";

export const Route = createFileRoute("/admin/media/$id")({
  component: AdminMediaDetailPage,
});
